var _circle, _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 386.71 303.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 198.89,
    cy: 150.16,
    r: 140,
    fill: "#ef5323"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 166,
    x: 48.89,
    y: 66.66,
    fill: "#d9d9d9",
    rx: 6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 160,
    x: 48.89,
    y: 66.66,
    fill: "#fff",
    rx: 6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 160,
    x: 48.89,
    y: 69.66,
    fill: "#f9f9f9",
    rx: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#eaeaea",
    d: "M58.89 152.66h280v1h-280z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ef5323",
    d: "M51.89 116.41h294v36h-294z",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#bfbfbf",
    d: "M58.89 131.66h30v6h-30zm56.69 0h40v6h-40zm57.18 0h30v6h-30zm66.44 0h40v6h-40zm56.69 0h30v6h-30z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#eaeaea",
    d: "M58.89 189.41h280v1h-280z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#bfbfbf",
    d: "M58.89 168.66h30v6h-30zm56.69 0h40v6h-40zm57.18 0h30v6h-30zm66.44 0h40v6h-40zm56.69 0h30v6h-30zm-237 37h30v6h-30zm56.69 0h40v6h-40zm57.18 0h30v6h-30zm66.44 0h40v6h-40zm56.69 0h30v6h-30z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#7f7f7f",
    d: "M58.89 90.16h40v8h-40zm56.94 0h30v8h-30zm56.43 0h50v8h-50zm66.69 0h30v8h-30zm56.94 0h40v8h-40z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M63 28.87a1 1 0 010 2c-4.33.82-9.59 2.32-12.24 5s-4.16 7.77-5 12.12a1 1 0 11-2 0C43 43.57 41.42 38.28 39 35.8s-8.21-4.11-12.69-5a1 1 0 010-2C30.81 28 36.58 26.39 39 24s4-8.19 4.87-12.79a1 1 0 112 0c.86 4.52 2.41 10.24 4.94 12.78S58.51 28 63 28.87zM20.46 9.78a1 1 0 01.72 1.22 1 1 0 01-.72.73c-2.3.56-4.7 1.42-6 2.76a13.63 13.63 0 00-2.75 6 1 1 0 01-1.94 0c-.57-2.33-1.43-4.74-2.68-6s-3.91-2.2-6.33-2.77a1 1 0 010-1.94c2.48-.59 5.1-1.47 6.3-2.67S9.14 3.26 9.73.76a1 1 0 011.94 0c.58 2.45 1.46 5.05 2.75 6.34s3.68 2.11 6.04 2.68zM23 43a.75.75 0 01.56.9.78.78 0 01-.56.56 9.87 9.87 0 00-4.55 2.08A9.83 9.83 0 0016.4 51a.75.75 0 01-1.4 0 10.32 10.32 0 00-2-4.52 10.58 10.58 0 00-4.77-2.07.74.74 0 01-.56-.9.73.73 0 01.51-.51c1.87-.45 3.85-1.11 4.75-2s1.58-2.9 2-4.78a.75.75 0 011.47 0A11.05 11.05 0 0018.48 41 10.55 10.55 0 0023 43zm305.79 234.35a1 1 0 010-2c4.33-.82 9.59-2.32 12.24-5s4.12-7.84 5-12.15a1 1 0 012 0c.87 4.39 2.38 9.68 4.86 12.16s8.21 4.11 12.69 5a1 1 0 010 2c-4.59.92-10.36 2.49-12.71 4.85s-4 8.17-4.84 12.78a1 1 0 01-2 0c-.86-4.52-2.41-10.25-4.94-12.78s-7.87-3.98-12.3-4.86zm35.91 18.88a.74.74 0 01-.56-.9.73.73 0 01.56-.56 7.17 7.17 0 006.62-6.6.75.75 0 011.46 0 10.14 10.14 0 002 4.52 10.72 10.72 0 004.74 2.08.75.75 0 01.56.9.78.78 0 01-.56.56c-1.87.45-3.84 1.11-4.75 2s-1.57 2.9-2 4.78a.77.77 0 01-.93.54.76.76 0 01-.54-.54c-.43-1.85-1.09-3.81-2.06-4.78a10.44 10.44 0 00-4.54-2zm1.57-32.8a1 1 0 010-1.93c2.3-.56 4.7-1.43 6-2.76s2.2-3.71 2.75-6a1 1 0 011.94 0c.57 2.33 1.43 4.74 2.68 6s3.88 2.18 6.29 2.75a1 1 0 01.75 1.19 1 1 0 01-.75.76c-2.48.59-5.1 1.47-6.3 2.67s-2.08 3.85-2.68 6.35a1 1 0 01-1.94 0c-.58-2.45-1.46-5-2.75-6.34s-3.63-2.12-5.99-2.69z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.1de578acadaaef310bdaa2f7560fa303.svg";
export { ForwardRef as ReactComponent };